import { LightningLanderThemeSettings } from "features/lightningLanders/types";
import React, { createContext, useContext, useState } from "react";

export const landerDefaultTheme: LightningLanderThemeSettings = {
  bodyFontFamily: "Arial, Helvetica, sans-serif",
  primaryColor: "#643dff",
  secondaryColor: "#7374ff",
  textColor: "#222",
  fontSizeH1: "34px",
  fontSizeH2: "32px",
  fontSizeH3: "26px",
  fontSizeH4: "22px",
  fontSizeH5: "20px",
  fontSizeH6: "18px",
  fontSizeBody: "16px",
  containerWidth: "1200px",
};

const LightningLanderThemeContext = createContext<{
  theme: LightningLanderThemeSettings;
  setTheme: React.Dispatch<React.SetStateAction<LightningLanderThemeSettings>>;
}>({
  theme: landerDefaultTheme,
  setTheme: () => { },
});

export const useLightningLanderThemeSettings = () =>
  useContext(LightningLanderThemeContext);

export const LightningLanderThemeProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [theme, setTheme] =
    useState<LightningLanderThemeSettings>(landerDefaultTheme);
  return (
    <LightningLanderThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </LightningLanderThemeContext.Provider>
  );
};
